export const LOCAL_STORAGE_LABELS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  NEW_COMPANY_ID: 'new_company_id',
  COMPANY_ID: 'company_id',
  PERIOD: 'period',
  STRIPE_REDIRECT: 'stripe_redirect',
  LINK_TOKEN: 'link_token',
  REDIRECT_TOKEN: 'redirect_token',
  REDIRECT_URL: 'redirect_url',
  CONTACT_SUCCESS: 'contact_success',
  REFRESH_API: 'refresh_api'
};
